import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    formSubtitle: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    listContainer: {
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
    },
    listItem: {
        display: "flex",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
        },
    },
}));
